import { Component, Inject } from '@angular/core';
import { authenticatedPatientSelector } from '../../../../main/selectors/patients-selectors';
import { AppState } from '../../../app.state';
import { Store } from '@ngrx/store';
import { DismissFlash } from '../store/flash.actions';
import { getFlashState } from '../store/flash.reducer';
import { State as FlashState } from '../store/flash.reducer';
import { Observable } from 'rxjs/Observable';
@Component({
  selector: 'flash-update-email',
  template: require('./flash-update-email.component.html'),
})
export class FlashUpdateEmailComponent {
  public disableSend: boolean = false;
  public flashState$: Observable<FlashState>;

  constructor(
    @Inject('$ngRedux') private $ngRedux,
    @Inject('PatientsService') private patientsService,
    private store: Store<AppState>,
  ) {}

  ngOnInit() {
    this.flashState$ = this.store.select(getFlashState);
  }

  resend() {
    this.disableSend = true;
    this.patientsService.changeEmail(this.authenticatedPatient.id, this.group.id, this.authenticatedPatient.unconfirmedEmail)
      .then(() => {
          setTimeout(() => {
            this.disableSend = false;
          }, 5000);
        },
      );
  }

  cancel() {
    this.patientsService.changeEmail(this.authenticatedPatient.id, this.group.id, null).then(() => {
      this.patientsService.loadPatient(this.authenticatedPatient.id).then(() => {
        this.store.dispatch(new DismissFlash());
      });
    });
  }

  get authenticatedPatient() {
    return authenticatedPatientSelector(this.$ngRedux.getState());
  }

  get group() {
    return this.$ngRedux.getState().group;
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/flash/flash-update-email/flash-update-email.component.ts